export const parseHtmlString = (htmlString: string): Document => {
	htmlString = htmlString.replace(/\s+<li/g, '<li');
	const parser = new DOMParser();
	return parser.parseFromString(htmlString, 'text/html');
};

export const serializeHtmlToString = (htmlDocument: Document): string => (
	htmlDocument.body.innerHTML
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/html-parse-serialize.ts